import { FadeLoader } from "react-spinners"

export default function Spinner() {
  return <FadeLoader color={"#7AF2A8"} />
}
